module.exports = __webpack_public_path__ + "static/media/pseudochorthippus_montanus_002_APA.d70616ba.mp3";